import React, { useState } from "react";

const OfferLetterModal = ({ candidate, offerData, onChange, onSubmit, onClose, children, loading }) => {
  if (!candidate && !children) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[99999] flex flex-col justify-end items-center">
      <div className="bg-white w-full max-h-[90vh] max-w-[600px] rounded-t-2xl shadow-xl p-5 overflow-y-auto transition-transform duration-300 animate-slide-up">

        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            {candidate
              ? <>Offer Letter - <span className="text-blue-600">{candidate.CandidateName}</span></>
              : "View Offer Letter"}
          </h2>
        </div>

        {/* Agar children diye ho to PDF iframe ya custom content render karo */}
        {children ? (
          <div className="w-full h-[75vh]">
            {children}
          </div>
        ) : (
          /* Form mode */
          <form onSubmit={onSubmit} className="space-y-5">
            {/* Candidate Info */}
            <div>
              <label className="block text-gray-600 mb-1">Candidate Name</label>
              <input
                type="text"
                value={candidate.CandidateName}
                disabled
                className="w-full border rounded-lg px-3 py-2 text-gray-700 bg-gray-100 text-sm"
              />
            </div>

            <div>
              <label className="block text-gray-600 mb-1">Email</label>
              <input
                type="email"
                value={candidate.CandidateEmail}
                disabled
                className="w-full border rounded-lg px-3 py-2 text-gray-700 bg-gray-100 text-sm"
              />
            </div>

            <div>
              <label className="block text-gray-600 mb-1">Role</label>
              <input
                type="text"
                value={candidate.Role}
                disabled
                className="w-full border rounded-lg px-3 py-2 text-gray-700 bg-gray-100 text-sm"
              />
            </div>

            {/* Dynamic Offer Fields */}
            {Object.entries({
              Salary: "Salary (e.g. 80000)",
              Address: "Office Address",
              ReportingManager: "Reporting Manager",
              JoiningDate: "Joining Date",
              WorkingHours: "Working Hours",
              StartTime: "Start Time",
              EndTime: "End Time",
            }).map(([name, placeholder]) => (
              <div key={name}>
                <label className="block text-gray-600 mb-1">{name}</label>
                <input
                  type={name === "JoiningDate" ? "date" : name.includes("Time") ? "time" : "text"}
                  name={name}
                  placeholder={placeholder}
                  value={offerData[name]}
                  onChange={onChange}
                  required
                  className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            ))}

            {/* Employment Type */}
            <div>
              <label className="block text-gray-600 mb-1">Nature of Employment</label>
              <select
                name="NatureofEmployment"
                value={offerData.NatureofEmployment}
                onChange={onChange}
                required
                className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
              >
                <option value="">Select</option>
                <option value="Full Time">Full Time</option>
                <option value="Part Time">Part Time</option>
                <option value="Remote">Remote</option>
                <option value="Other">Other</option>
              </select>
            </div>

            {offerData.NatureofEmployment === "Other" && (
              <div>
                <label className="block text-gray-600 mb-1">Other Employment Detail</label>
                <input
                  name="OtherEmploymentDetail"
                  placeholder="Specify Other Employment"
                  value={offerData.OtherEmploymentDetail}
                  onChange={onChange}
                  className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            )}

            {/* Notice & Probation */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-gray-600 mb-1">Notice Period (days)</label>
                <input
                  type="number"
                  name="SubjecttoTermination"
                  placeholder="e.g. 30"
                  value={offerData.SubjecttoTermination}
                  onChange={onChange}
                  required
                  className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
              <div>
                <label className="block text-gray-600 mb-1">Probation Period (months)</label>
                <input
                  type="number"
                  name="ProbationPeriod"
                  placeholder="e.g. 6"
                  value={offerData.ProbationPeriod}
                  onChange={onChange}
                  required
                  className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={onClose}
                className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {loading ? (
                  "Submitting..."
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default OfferLetterModal;
